/* Shop categories switch in place: fetch the category page, swap only the catalog section, keep the page where it is. */
(() => {
  const SEL = '[data-ma-shop-concept]';
  if (!document.querySelector(SEL) || !window.fetch || !window.DOMParser || !history.pushState) return;

  const cache = new Map();
  const preview = new URLSearchParams(location.search).get('preview_theme_id');
  const withPreview = (path) => {
    const url = new URL(path, location.origin);
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url.toString();
  };
  const load = (path) => {
    if (!cache.has(path)) {
      cache.set(path, fetch(withPreview(path), { credentials: 'same-origin' })
        .then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); })
        .catch((e) => { cache.delete(path); throw e; }));
    }
    return cache.get(path);
  };
  const pathOf = (a) => { const u = new URL(a.href, location.origin); return u.origin === location.origin ? u.pathname + u.search : null; };

  let token = 0;
  const go = async (path, push) => {
    const root = document.querySelector(SEL);
    const section = root && root.closest('.shopify-section');
    if (!section) { location.assign(path); return; }
    const grid = section.querySelector('[data-product-grid]');
    if (grid) { grid.style.transition = 'opacity .18s ease'; grid.style.opacity = '0.35'; }
    const mine = ++token;
    let html;
    try { html = await load(path); } catch (e) { location.assign(path); return; }
    if (mine !== token) return;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.getElementById(section.id) || (doc.querySelector(SEL) && doc.querySelector(SEL).closest('.shopify-section'));
    if (!next) { location.assign(path); return; }

    const sortBefore = section.querySelector('[data-product-sort]');
    const sortValue = sortBefore ? sortBefore.value : null;

    section.innerHTML = next.innerHTML;
    section.querySelectorAll('script').forEach((old) => {
      const s = document.createElement('script');
      [...old.attributes].forEach((attr) => s.setAttribute(attr.name, attr.value));
      s.textContent = old.textContent;
      old.replaceWith(s);
    });

    /* The collection questions below the grid belong to the category too. */
    document.querySelectorAll('.shopify-section[id$="__questions"]').forEach((el) => {
      const fresh = doc.getElementById(el.id);
      el.innerHTML = fresh ? fresh.innerHTML : '';
    });

    const sort = section.querySelector('[data-product-sort]');
    if (sort && sortValue && sort.value !== sortValue && [...sort.options].some((o) => o.value === sortValue)) {
      sort.value = sortValue;
      sort.dispatchEvent(new Event('change', { bubbles: true }));
    }

    document.title = doc.title;
    const meta = doc.querySelector('meta[name="description"]');
    const metaNow = document.querySelector('meta[name="description"]');
    if (meta && metaNow) metaNow.setAttribute('content', meta.getAttribute('content'));
    const canon = doc.querySelector('link[rel="canonical"]');
    const canonNow = document.querySelector('link[rel="canonical"]');
    if (canon && canonNow) canonNow.setAttribute('href', canon.getAttribute('href'));
    if (push) history.pushState({ maShop: true }, '', path);

    /* If the visitor had scrolled into the grid, bring the top of the new results into view. */
    const newGrid = section.querySelector('[data-product-grid]');
    if (newGrid) {
      const top = newGrid.getBoundingClientRect().top;
      if (top < 0) window.scrollTo({ top: Math.max(0, top + window.scrollY - 170), behavior: 'smooth' });
    }
    const active = section.querySelector('a.filter.active');
    if (active && active.parentElement && active.parentElement.scrollWidth > active.parentElement.clientWidth) {
      active.parentElement.scrollTo({ left: active.offsetLeft - (active.parentElement.clientWidth - active.offsetWidth) / 2, behavior: 'smooth' });
    }
    document.dispatchEvent(new CustomEvent('ma:shop-updated', { detail: { path } }));
  };

  /* Capture phase on window, so this runs before the theme's page-transition link handler. */
  window.addEventListener('click', (event) => {
    const a = event.target.closest && event.target.closest('a.filter[href]');
    if (!a || !a.closest(SEL)) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const path = pathOf(a);
    if (!path) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (a.classList.contains('active')) return;
    a.closest(SEL).querySelectorAll('a.filter').forEach((f) => {
      const on = f === a;
      f.classList.toggle('active', on);
      if (on) f.setAttribute('aria-current', 'page'); else f.removeAttribute('aria-current');
    });
    go(path, true);
  }, true);

  /* Start loading a category as soon as the pointer or finger lands on it. */
  const warm = (event) => {
    const a = event.target.closest && event.target.closest('a.filter[href]');
    if (!a || !a.closest(SEL) || a.classList.contains('active')) return;
    const path = pathOf(a);
    if (path) load(path).catch(() => {});
  };
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('touchstart', warm, { passive: true });

  history.replaceState({ maShop: true }, '');
  window.addEventListener('popstate', () => {
    if (document.querySelector(SEL)) go(location.pathname + location.search, false);
  });
})();
